<div class="logo-wrapper">
  <img src="/assets/svg/rtr-logo.svg" alt="Rio Rewrite Logo" class="logo" />
</div>
